import _request from '@/utils/request.js'

var _royaltyPlan = {
  // 提成方案列表
  queryPlanList (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/query/plan/list"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 提成方案列表
  planStateUpdate (id, state, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/state/update"),
      params: {
        id: id,
        state: state
      },
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 提成方案保存（第一步）
  planFirstAdd (info, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/first/add"),
      data: info,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  // 提成方案保存（第二步）
  planSecondAdd (info, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/second/add"),
      data: info,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  // 提成方案详情
  royaltyPlanDetalis (id, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/royalty/plan/details"),
      params: {
        id: id
      },
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 提成方案保存（第一步）
  planFirstEdit (info, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/first/edit"),
      data: info,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  // 提成方案保存（第二步）
  planSecondEdit (info, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/second/edit"),
      data: info,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  // 根据活动标识查询提成方案
  queryActivityPlan (activityId, saleAmount, faceValue, total, storedType, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/query/activity/plan"),
      params: {
        activityId: activityId,
        saleAmount: saleAmount,
        faceValue: faceValue,
        storedType: storedType,
        total: total
      },
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 根据模板标识查询提成方案
  queryTemplatePlan (templateId, saleAmount, faceValue, total, storedType, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/query/template/plan"),
      params: {
        templateId: templateId,
        saleAmount: saleAmount,
        faceValue: faceValue,
        storedType: storedType,
        total: total
      },
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 根据活动标识查询提成方案
  queryActivityPlan (templateId, saleAmount, faceValue, total, storedType, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/plan/query/activity/plan"),
      params: {
        activityId: templateId,
        saleAmount: saleAmount,
        faceValue: faceValue,
        storedType: storedType,
        total: total
      },
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 查询所有平台应用列表
  getAppPlatformList (resolve, reject) {
    _request.api({
        url     : _request.getCardsUrl("/api/cardstemplate/getAppPlatformList"),
        method  : 'get',
        success : resolve,
        error   : reject
    })
  },
  // 根据应用code查询对应的规则
  getRuleListByPlatform (ruleCodeUrl, resolve, reject) {
    _request.api({
        url     : _request.getCardsUrl(ruleCodeUrl),
        method  : 'get',
        success : resolve,
        error   : reject
    })
  },
  // 查询所有平台应用列表
  updateVisibility (params,resolve, reject) {
    _request.api({
        url     : _request.getCrmUrl("/plan/updateVisibility"),
        params,
        method  : 'get',
        success : resolve,
        error   : reject
    })
  },
}

export default _royaltyPlan